import { BrandsList } from "models/BrandsList/BrandsList.model";
import { CategoryOptions } from "./ProductModalForm";

export const getDefaultFileList = (url: string) => {
  return [
    {
      uid: '-1',
      name: 'default-file.png',
      status: 'done',
      url: url,
    },
  ];
};

export const convertToOptions = (
  data: BrandsList[]
) => {
  const options: CategoryOptions[] = [];
  data.map((item: BrandsList) => {
    options.push({
      label: item.name,
      value: item.id,
      key: item.id,
    });
  });
  return options;
};